// @ts-check

if (!customElements.get('ff-tabs')) {
  class FfTabs extends HTMLElement {
    constructor() {
      super();
      this.ffInit();
    }

    ffInit = () => {
      const header = this.querySelector('.ff-tabs__header');
      const items = this.querySelectorAll('[data-ff-tab-item]');
      if (!header || !items.length) return;

      // Move each tab trigger into the header (triggers render inline inside
      // their tab-item block, then we relocate them to get a shared top row).
      items.forEach((item) => {
        const trigger = item.querySelector('[data-ff-tab-trigger]');
        if (trigger && !trigger._ffMoved) {
          header.appendChild(trigger);
          trigger._ffMoved = true;
        }
      });

      let active = header.querySelector('[data-ff-active]') || header.querySelector('[data-ff-tab-trigger]');
      if (active) this.ffActivate(active);

      header.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-ff-tab-trigger]');
        if (!trigger || !header.contains(trigger)) return;
        this.ffActivate(trigger);
      });

      header.addEventListener('keydown', (e) => {
        const triggers = Array.from(header.querySelectorAll('[data-ff-tab-trigger]'));
        const current = document.activeElement;
        const idx = triggers.indexOf(current);
        if (idx === -1) return;

        let next;
        if (e.key === 'ArrowRight') next = triggers[(idx + 1) % triggers.length];
        else if (e.key === 'ArrowLeft') next = triggers[(idx - 1 + triggers.length) % triggers.length];
        else if (e.key === 'Home') next = triggers[0];
        else if (e.key === 'End') next = triggers[triggers.length - 1];

        if (next) {
          e.preventDefault();
          next.focus();
          this.ffActivate(next);
        }
      });
    };

    ffActivate = (trigger) => {
      if (!trigger) return;
      const targetId = trigger.getAttribute('data-ff-panel-id');

      this.querySelectorAll('[data-ff-tab-trigger]').forEach((t) => {
        const isActive = t === trigger;
        t.classList.toggle('ff-tab-trigger--active', isActive);
        t.setAttribute('aria-selected', String(isActive));
        t.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.querySelectorAll('[data-ff-tab-panel]').forEach((p) => {
        const isActive = p.id === targetId;
        p.classList.toggle('ff-tab-panel--active', isActive);
        if (isActive) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
    };
  }

  customElements.define('ff-tabs', FfTabs);
}

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    requestAnimationFrame(() => {
      document.querySelectorAll('ff-tabs').forEach((el) => {
        if (typeof el.ffInit === 'function') el.ffInit();
      });
    });
  });
}
